/**
 * Feed Imports list: hide finished manual regenerations (Jaume 2026-10-30 ~07:05Z).
 *
 * Every manual regeneration INSERTs its own '[Manual Regeneration <runId>]' config (feed_url
 * 'manual://regeneration') as an immutable per-run snapshot of its options
 * (backend-merged/services/BulkRegenRunService.js, 2026-05-12 race fix). Those rows are never
 * scheduled and are never deleted (a delete cascades into runs, sub-batches and enrichment jobs that
 * waivers and cost audits read), so they pile up on this page. A finished one is hidden by default;
 * one whose latest run is still in flight always stays visible. Display only: no data is changed.
 */

export const TERMINAL_RUN_STATUSES: ReadonlySet<string> = new Set(['completed', 'failed', 'cancelled']);

interface ConfigLike {
  name: string;
  feed_url: string;
  latest_run?: { status?: string | null } | null;
}

export function isManualRegeneration(config: ConfigLike): boolean {
  return config.feed_url === 'manual://regeneration' || config.name.startsWith('[Manual Regeneration');
}

/** Hidden by default only when it is a manual regeneration AND its latest run is terminal. */
export function isFinishedManualRegeneration(config: ConfigLike): boolean {
  const status = config.latest_run?.status;
  return isManualRegeneration(config) && typeof status === 'string' && TERMINAL_RUN_STATUSES.has(status);
}

export function partitionFeedConfigs<T extends ConfigLike>(configs: T[], showFinishedManual: boolean): { visible: T[]; hiddenCount: number } {
  const hidden = configs.filter(isFinishedManualRegeneration);
  return {
    visible: showFinishedManual ? configs : configs.filter((c) => !isFinishedManualRegeneration(c)),
    hiddenCount: hidden.length,
  };
}
